const settingInfo = JSON.parse(localStorage.getItem('settingInfo')) || {}

const state = {
  applyDiscount: settingInfo.applyDiscount || false,
  enabled: settingInfo.credits || [],

  filters: [
    {
      id: 'freeTier',
      propName: 'frt',
      isDiscount: true,
    },
    {
      id: 'sustainedUsageDiscount',
      propName: 'sud',
      isDiscount: true,
    },
    {
      id: 'committedUsageDiscount',
      propName: 'cud',
      isDiscount: true,
    },
    {
      id: 'spendingBasedDiscount',
      propName: 'sbd',
      isDiscount: true,
    },
    {
      id: 'promotion',
      propName: 'prm',
      isDiscount: false,
    },
    {
      id: 'subscriptionBenefitDiscount',
      propName: 'sb',
      isDiscount: true,
    },
  ],
}

const mutations = {
  applyDiscount(_state, val) {
    _state.applyDiscount = val
  },

  enabled(_state, val) {
    _state.enabled = val
  },
}

export default {
  namespaced: true,

  state,
  mutations,
}
